import React from 'react';

import FarmCard from './FarmCard';
import { Box, Flex, Heading, Grid } from '@chakra-ui/core';

const FarmSection = ({
  title,
  farms,
  setSession,
  menuOpen,
  setUnexpectedError,
  fetchActivities
}) => {
  return (
    <Box bg="cf.100" py={20} px={{ lg: 48 }} pl={{ base: 14, md: 20 }} pr={{ base: 4, md: 5 }}>
      <div className="container mx-auto py-16">
        <Box w={{ base: '100%', md: 145 }} mx="auto">
          <Flex wrap="wrap" justify="space-between" align="center">
            <Heading as="h4">Your {title} Farms</Heading>
          </Flex>

          <Grid
            templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
            columnGap={{ md: 4 }}
            gridGap={{ md: 4 }}
            px={{ base: 2, md: 0 }}
          >
            {farms &&
              farms.map(farm => (
                <FarmCard
                  key={farm._id}
                  data={farm}
                  setSession={setSession}
                  setUnexpectedError={setUnexpectedError}
                  fetchActivities={fetchActivities}
                />
              ))}
          </Grid>
        </Box>
      </div>
    </Box>
  );
};

export default FarmSection;
